/**
 * C-1 — mesaj katalogları. Pilotta bileşenler react-intl <FormattedMessage defaultMessage>
 * kullanıyor; bu yüzden taban katalog BOŞ başlar (eksik anahtar = defaultMessage). Anahtarlar
 * biriktikçe buraya (paylaşılan) ya da uygulama kataloğuna taşınır; ZercodeIntlProvider ikisini
 * birleştirir. Bu, "önce model dursun, retrofit maliyeti artmasın" ilkesidir.
 */
import { Locale } from './locales';

export type MessageCatalog = Record<string, string>;

/** Paylaşılan taban katalog (şimdilik boş — uygulama kataloğuyla birleştirilir). de/ar altyapı
 *  olarak var; boş → defaultMessage'a (pilot en/tr) düşer, çeviriler biriktikçe dolar. */
export const baseMessages: Record<Locale, MessageCatalog> = {
  en: {},
  tr: {},
  de: {},
  ar: {}
};

/** Taban + uygulama kataloğunu bir locale için birleştirir (uygulama üzerine yazar). */
export function mergeCatalog(locale: Locale, appMessages?: Partial<Record<Locale, MessageCatalog>>): MessageCatalog {
  return { ...baseMessages[locale], ...(appMessages?.[locale] ?? {}) };
}
